module.exports = __webpack_public_path__ + "static/media/BM_Quotes.d9981586.svg";